import $ from "../../libs/jquery-3.3.1.min.js"
import {gsap} from "../../libs/gsap/all.js";
import * as PIXI from "pixi.js";
import 'pixi.js/math-extras'
import {BaseMiniGame} from "./BaseMiniGame";
import {Player} from "../components/Player";
import {SolidHarponTile} from "../components/HarponTiles/SolidHarponTile";
import {HoleHarponTile} from "../components/HarponTiles/HoleHarponTile";
import {DisabledHarponTile} from "../components/HarponTiles/DisabledHarponTile";
import {DrainHarponTile} from "../components/HarponTiles/DrainHarponTile";
import {BearHarponTile} from "../components/HarponTiles/BearHarponTile";
import {EndHarponTile} from "../components/HarponTiles/EndHarponTile";
import {Life} from "../components/Life";
import {Tempete} from "../components/Tempete";
import {GameAudio} from "../components/GameAudio";
import {OpenWater} from "../components/OpenWater";
import {WaterHarponTile} from "../components/HarponTiles/WaterHarponTile";
import {PlayerAudio} from "../components/PlayerAudio";
import {PlayerSelectTiles} from "../components/PlayerSelectTiles";
import {BearMaskHarponTile} from "../components/HarponTiles/BearMaskHarponTile";

// Game description : Tambour
export class GameHarpon extends BaseMiniGame {

  // Constructor
  constructor(data) {
    super(data);
    this.appWidth = this.data.appDimensions.width;
    this.appHeight = this.data.appDimensions.height;

    this.gameTemplates = this.data.gameTemplates;
    this.currentGameTemplateIndex = -1;
    this.currentGameTemplate = this.getRandomGameTemplate();

    this.$screenEl = null;

    this.isInGame = false;
    this.actionsLocked = true;
    this.gameComplete = false;

    this.lives = [];
    this.maxLives = 3;
    this.livesLost = 0;

    this.gridDimensions = {rows: 17, cols: 9};
    this.tiles = Array.from({length: this.gridDimensions.rows}, () => Array(this.gridDimensions.cols).fill(0));
    this.maskTiles = [];

    this.timerBarPositions = {from: 35, to: 1050};
    this.gameDuration = 150; // seconds before night arrives

    this.errorOverlay = null;

    this.currentState = "instructions-step-1";

    this.lockPlayerActions();

    // TODO: remove debug line
    globalThis.__PIXI_APP__ = this;
  }

  async assetLoader() {
    await super.assetLoader();

    if (this.data.medias && this.data.medias.length) {
      for (let i = 0; i < this.data.medias.length; i++) {
        this.assets[this.data.medias[i].name] = await PIXI.Assets.load(this.data.medias[i].url);
      }
    }
  }

  async buildStage() {

    this.$screenEl = $(this.canvas).parents(".screen");

    this.buildBackground();
    this.buildPlayerTiles();
    this.buildGrid();
    this.buildOpenWater();
    this.buildPlayer();
    this.buildPlayerMaskLayer();
    this.buildTempete();
    this.buildUI();

    this.gameAudio = new GameAudio();
    this.playerAudio = new PlayerAudio();

    this.errorOverlay = new PIXI.Sprite(this.assets["collision-glow"]);
    this.errorOverlay.alpha = 0;
    this.stage.addChild(this.errorOverlay);

    this.initEvents();
  }

  buildBackground() {
    this.backgroundContainer = new PIXI.Container();
    this.stage.addChild(this.backgroundContainer);

    this.gridMask = new PIXI.Sprite(this.assets["grid-mask"]);
    this.stage.addChild(this.gridMask);

    this.gridWindAnim = new PIXI.Sprite(this.assets["grid-wind-animation"]);
    this.gridWindAnim.texture.source.resource.loop = true;
    this.gridWindAnim.position.y = 684;
    this.gridWindAnim.scale.set(1.15);
    this.gridWindAnim.texture.source.resource.pause();
    // this.gridWindAnim.mask = this.gridMask;
    this.backgroundContainer.addChild(this.gridWindAnim);
  }

  buildPlayerTiles() {
    this.playerSelectTiles = new PlayerSelectTiles();
    this.stage.addChild(this.playerSelectTiles);
  }

  buildGrid() {

    // In the json file you can set to show or hide the grid template, useful to create new games easily
    if (this.data.show_tiles_grid) {
      this.gridTemplate = new PIXI.Sprite(this.assets["grid-template"]);
      this.gridTemplate.position.y = 160;
      this.backgroundContainer.addChild(this.gridTemplate);
    }

    this.tilesContainer = new PIXI.Container();
    this.stage.addChild(this.tilesContainer);

    this.tilesContainer.mask = this.gridMask;

    this.playerTilesMaskContainer = new PIXI.Container();
    /// Will be added to stage in a later step for zIndex purpose

    this.generateTiles();
  }

  getRandomGameTemplate() {
    this.currentGameTemplateIndex = (this.currentGameTemplateIndex + 1) % this.gameTemplates.length;
    return this.gameTemplates[this.currentGameTemplateIndex];
  }

  generateTiles() {
    // reset the tiles array
    this.tiles = Array.from({length: this.gridDimensions.rows}, () => Array(this.gridDimensions.cols).fill(0));
    this.maskTiles = [];

    let currentGameTileset = this.currentGameTemplate["tiles"];

    let baseX = 4;
    let baseY = 762;
    let colsWidth = 234;
    let rowsHeight = 160;
    let evenColsOffset = rowsHeight / 2 - 2;
    let rowsSpacing = 4;

    for (let i = 0; i < this.gridDimensions.rows; i++) {

      for (let j = 0; j < this.gridDimensions.cols; j++) {

        let tile = null;
        let maskTile = null;

        switch (currentGameTileset[i][j]) {
          case "hole":
            tile = new HoleHarponTile(i, j);
            break;
          case "disabled":
            tile = new DisabledHarponTile(i, j);
            break;
          case "bear":
            tile = new BearHarponTile(i, j);
            maskTile = new BearMaskHarponTile(i, j);
            break;
          case "drain":
            tile = new DrainHarponTile(i, j);
            break;
          case "water":
            tile = new WaterHarponTile(i, j);
            break;
          case "end":
            tile = new EndHarponTile(i, j);
            break;
          default:
            tile = new SolidHarponTile(i, j);
            break;
        }

        tile.position.set(baseX + (j * colsWidth), baseY + (i * rowsHeight) + rowsSpacing);

        if (j % 2 != 0) {
          tile.position.y += evenColsOffset;
        }

        this.tiles[i][j] = tile;
        this.tilesContainer.addChild(tile);

        if (maskTile) {
          maskTile.position.set(baseX + (j * colsWidth), baseY + (i * rowsHeight) + rowsSpacing);

          if (j % 2 != 0) {
            maskTile.position.y += evenColsOffset;
          }
          this.maskTiles.push(maskTile);
          this.playerTilesMaskContainer.addChild(maskTile);
          tile.maskTile = maskTile;
        }

      }
    }
  }

  buildPlayer() {
    this.player = new Player();
    this.playerSelectTiles.build();
    this.player.hideSelectTiles();
    this.player.setDirection();

    this.stage.addChild(this.player);
  }

  buildPlayerMaskLayer() {
    // this.playerTilesMaskContainer = new PIXI.Container();
    this.stage.addChild(this.playerTilesMaskContainer);
  }

  buildTempete() {
    this.tempete = new Tempete();
    this.stage.addChild(this.tempete);
    this.prepareTempete();
  }

  prepareTempete() {
    this.tempete.reset();
    // Let's get the start position
    let targetRow = Math.min(this.currentGameTemplate.tempete.start + 2, this.tiles.length - 1); // we want to set the sprite position 2 rows below the starting row
    let startY = this.tiles[targetRow][0].position.y + this.tiles[targetRow][0].height;
    this.tempete.setPosition(startY);
  }

  buildOpenWater() {
    this.openWater = new OpenWater();
    this.stage.addChild(this.openWater);
    this.prepareOpenWater();
  }

  prepareOpenWater() {
    // Let's get the start position
    this.openWater.reset();
    this.openWater.setPosition(this.currentGameTemplate.water_side);
  }

  buildUI() {
    this.uiContainer = new PIXI.Container();
    this.uiContainer.position.set(0, 0);
    this.stage.addChild(this.uiContainer);

    this.uiContainer.alpha = 0;

    this.uiBackground = new PIXI.Sprite(app.game.assets["ui-background"]);

    this.timerBarFilter = new PIXI.ColorMatrixFilter();
    this.timerBarFilter.saturateValue = 1;
    this.timerBarFilter.brightnessValue = 1;

    this.timerBarContainer = new PIXI.Container();
    this.timerBarContainer.position.set(206, 171);
    this.timerBar = new PIXI.Graphics().rect(0, 0, this.timerBarPositions.from, 30).fill(0x1b325a);
    this.timerBar.filters = [this.timerBarFilter];
    this.timerBar.pivot.set(0, 30 / 2);
    this.timerPin = new PIXI.Sprite(app.game.assets["ui-timer-pin"]);
    this.timerPin.anchor.set(0.5);
    this.timerPin.position.set(this.timerBarPositions.from, 0);
    this.timerBarContainer.addChild(this.timerBar, this.timerPin);

    this.uiSun = new PIXI.Sprite(app.game.assets["ui-sun"]);
    this.uiSun.anchor.set(0.5);
    this.uiSun.position.set(170, 171);

    this.uiMoon = new PIXI.Sprite(app.game.assets["ui-moon"]);
    this.uiMoon.anchor.set(0.5);
    this.uiMoon.position.set(1318, 171);

    this.uiContainer.addChild(this.uiBackground, this.timerBarContainer, this.uiSun, this.uiMoon);

    // Lives
    this.livesAreaContainer = new PIXI.Container();
    this.livesAreaContainer.position.set(1680, 170);

    let baseLivesX = 0;
    let baseLivesSpacing = 2;

    for (let i = 0; i < 3; i++) {
      let life = new Life();
      life.position.set(baseLivesX + (i * (life.width + baseLivesSpacing)), 0);
      this.livesAreaContainer.addChild(life);
      this.lives.push(life);
    }

    this.uiContainer.addChild(this.livesAreaContainer);

    // We'll create the game timer here because it will change the UI too
    this.gameTimerTimeline = gsap.timeline({
      paused: true,
      onComplete: () => {
        // Game timer ended before player reached the end.
        this.endGame();
        app.animateOutGame(8);
      }
    });

    this.gameTimerTimeline.fromTo(this.timerBar, {
        pixi: {
          width: this.timerBarPositions.from,
        },
      }, {
        pixi: {
          width: this.timerBarPositions.to,
        },
        overwrite: "auto",
        duration: this.gameDuration,
        ease: "none"
      }
    );

    this.gameTimerTimeline.fromTo(this.timerPin,
      {
        pixi: {
          x: this.timerBarPositions.from,
        },
      }, {
        pixi: {
          x: this.timerBarPositions.to,
        },
        overwrite: "auto",
        duration: this.gameDuration,
        ease: "none",

      }, 0);

    this.gameTimerTimeline.fromTo($(".main-background-ciel.night, #game-night-overlay, #game-houses-glow-overlay"),
      {
        opacity: 0,
      }, {
        opacity: 1,
        duration: this.gameDuration,
        ease: "none",
        overwrite: "auto",
      }, 0)

    // Animate the color of the timeBar fill across night and day
    this.gameTimerTimeline.fromTo(this.timerBarFilter,
      {
        brightnessValue: 1,
        saturateValue: 1
      }, {
        duration: this.gameDuration,
        ease: "none",
        overwrite: "auto",
        brightnessValue: 2.2,
        saturateValue: -0.2,
        onUpdate: () => {
          this.timerBarFilter.brightness(this.timerBarFilter.brightnessValue, false)
          this.timerBarFilter.saturate(this.timerBarFilter.saturateValue, true)
        }
      }, 0)

  }

  initEvents() {
    let keyMap = {};

    Object.keys(app.settings.keys).forEach(function (key) {
      if (app.settings.keys[key]) {
        keyMap[app.settings.keys[key]] = key;
      }
    });

    $(document).keydown((e) => {
      // Make sure the screensaver delay is reset when we hit a note because we are not touching the screen
      app.resetTimer();

      if (this.isInGame) {

        if ($("#screen-activity-check").hasClass("shown")) {
          // prevent presses when screen saver is visible as it is handled in the main game
          // console.log("prevent presses when screen saver is visible as it is handled in the main game");
          return;
        }

        if (keyMap.hasOwnProperty(e.keyCode)) {
          const keyName = keyMap[e.keyCode]

          // In every step we can change direction
          if (["left", "center", "right"].includes(keyName)) {
            this.player.setDirection(keyName)
          }

          // There will be different actions possible based on the step we are in
          if (this.currentState === "instructions-step-1") {
            // On step 1, once the player moves in a direction, we go to step 2
            if (["left", "center", "right"].includes(keyName)) {
              this.currentState = "instructions-step-2";

              gsap.to(this.$screenEl.find(".instructions-step[data-step='1']"), {
                alpha: 0.0,
                duration: 0.30,
                ease: "power3.out",
                overwrite: "auto"
              });

              gsap.to(this.$screenEl.find(".instructions-step[data-step='2']"), {
                alpha: 1.0,
                duration: 0.30,
                delay: 0.30,
                ease: "power3.out",
                overwrite: "auto"
              });
            }

          } else if (this.currentState === "instructions-step-2") {
            // On step 2 we need to test a tile 3 times to go to step 3
            if (["test"].includes(keyName)) {
              this.testTile()

              // Now check if the tile is revealed, if so, proceed to game
              if (this.testedTileIsRevealed()) {
                this.currentState = "instructions-step-3";

                gsap.to(this.$screenEl.find(".instructions-step[data-step='2']"), {
                  alpha: 0.0,
                  duration: 0.30,
                  ease: "power3.out",
                  overwrite: "auto"
                });

                gsap.to(this.$screenEl.find(".instructions-step[data-step='3']"), {
                  alpha: 1.0,
                  duration: 0.30,
                  delay: 0.30,
                  ease: "power3.out",
                  overwrite: "auto"
                });
              }
            }

          } else if (this.currentState === "instructions-step-3") {
            // On step 3 we do all the actions and we wait for a good move to proceed
            if (["left", "center", "right"].includes(keyName)) {
              this.player.setDirection(keyName)
            }

            if (["move"].includes(keyName)) {
              this.player.move();
            }

            if (["test"].includes(keyName)) {
              this.testTile()
            }

          } else if (this.currentState === "game") {
            // normal game actions

            // We need to listen to these actions always, even if actions are locked
            // Because the physical harpon can move even while we are animating
            // so we need to keep track of its position always even if we are not visually updating the tiles
            if (["left", "center", "right"].includes(keyName)) {
              this.player.setDirection(keyName)
            }

            // These actions can only happen when the actions are unlocked
            if (this.actionsEnabled()) {
              if (["move"].includes(keyName)) {
                this.player.move()
              }

              if (["test"].includes(keyName)) {
                this.testTile()
              }
            }

            // This would never happen in prod, it's just used for dev
            if (app.debugMode) {
              if (["cheat"].includes(keyName)) {
                this.revealHiddenTiles(true)
              }
            }

          }
        }
      } else {
        // console.log("not in game, locked");
      }
    });

    // TODO Remove keyup listener
    $(document).keyup((e) => {
      if (this.isInGame) {
        if (keyMap.hasOwnProperty(e.keyCode)) {
          // The physical interface doesn't have an idle state. It is always aiming toward UP/FRONT/RIGHT
          // So the player is never in 'idle' state. We don't have to listen to keyup.
          // this.setDirection("idle");
          const keyName = keyMap[e.keyCode]

          if (app.debugMode) {
            if (["cheat"].includes(keyName)) {
              this.revealHiddenTiles(false)
            }
          }
        }
      }
    });

    //add listener
    // this.ticker.add(this.progress.bind(this));
  }

  actionsEnabled() {
    return this.isInGame && !this.actionsLocked;
  }

  getTile(row, col) {
    return this.tiles[row][col];
  }

  unlockPlayerActions() {
    this.actionsLocked = false;
  }

  lockPlayerActions() {
    this.actionsLocked = true;
  }

  testTile() {
    if (!this.actionsEnabled()) {
      return;
    }

    // target tile can be undefined if we are at the edge of the screen and facing "outside" the screen
    if (typeof this.player.targetTile === "undefined") {
      app.audio.play(app.data.global.sounds.blocked_tile, 1.0, true);
      return;
    }

    this.player.targetTile.test();
  }

  testedTileIsRevealed() {
    return this.player.targetTile.shown;
  }

  validateTile() {
    return this.player.targetTile.validate();
  }

  revealHiddenTiles(show = true) {
    for (let i = 0; i < this.tiles.length; i++) {
      for (let j = 0; j < this.tiles[i].length; j++) {
        if (!this.tiles[i][j].shown && typeof this.tiles[i][j].testedTile !== "undefined") {
          this.tiles[i][j].testedTile.alpha = show ? 1 : 0;
        }
      }
    }
  }

  loseLife() {
    if (this.currentState === "game") {
      this.livesLost++;

      if (this.livesLost >= this.maxLives) {
        return true;
      }
    }

    return false;
  }

  updateLives() {
    for (let i = 0; i < this.lives.length; i++) {
      if (i < this.livesLost) {
        this.lives[i].animateLoseLife();
      }
    }
  }

  endOfTurnAction() {
    // Specific Tiles actions will be handle by themselves
    for (let i = 0; i < this.tiles.length; i++) {
      for (let j = 0; j < this.tiles[i].length; j++) {
        this.tiles[i][j].endOfTurnAction();
      }
    }

    this.openWater.endOfTurnAction();
    this.tempete.endOfTurnAction();

    return this.gameComplete;
  }

  progress(ticker) {

  }

  closeInstructions() {
    if (this.currentState !== "game") {
      this.currentState = "game";

      let closeInstructionsTimeline = gsap.timeline();

      closeInstructionsTimeline.to(this.$screenEl.find(".game-instructions"), {
        alpha: 0.0,
        duration: 0.30,
        ease: "power3.out",
        overwrite: "auto"
      });

      closeInstructionsTimeline.to(this.$screenEl.find(".instructions-step[data-step='3']"), {
        alpha: 0.0,
        duration: 0.30,
        ease: "power3.out",
        overwrite: "auto"
      }, 0);

      closeInstructionsTimeline.fromTo(this.uiContainer, {
          pixi: {
            alpha: 0,
          },
        }, {
          pixi: {
            alpha: 1,
          },
          overwrite: "auto",
          duration: 0.5,
          ease: "power3.out",
        }
      );

      this.isInGame = true;
      this.startGameTimer();
    }
  }

  beforeAnimateIn() {
    this.player.setDirection(this.player.currentDirection, true);

    // Make sure loop videos are playing correctly
    this.gridWindAnim.texture.source.resource.play();
    this.gameAudio.start();
  }

  beforeAnimateOut() {
    this.lockPlayerActions();
    this.gameTimerTimeline.pause();
  }

  begin() {
    this.isInGame = true;
    this.player.setDirection(this.player.currentDirection, true);

    this.unlockPlayerActions();
  }

  startGameTimer() {
    this.gameTimerTimeline.play(0);
  }

  endGame() {
    this.lockPlayerActions();
    this.gameTimerTimeline.pause();

    this.gameAudio.stop();
    this.playerAudio.stop();
    this.tempete.stop();
  }

  reset() {
    this.lockPlayerActions();

    // reset values
    this.currentState = "instructions-step-1";
    this.isInGame = false;

    this.livesLost = 0;
    for (let i = 0; i < this.lives.length; i++) {
      this.lives[i].reset()
    }

    this.gameComplete = false;

    this.gameAudio.reset();
    this.playerAudio.reset();
    this.gameTimerTimeline.pause().seek(0);
    this.tempete.reset();

    // Force Pause the wind video and we'll make it play when needed
    this.gridWindAnim.texture.source.resource.pause();

    this.uiContainer.alpha = 0;

    // reset the tiles array
    for (let i = 0; i < this.tiles.length; i++) {
      for (let j = 0; j < this.tiles[i].length; j++) {
        this.tiles[i][j].destroy();
        this.tiles[i][j] = null;
      }
    }

    for (let i = 0; i < this.maskTiles.length; i++) {
      console.log("destroy tile");
      this.maskTiles[i].destroy();
      this.maskTiles[i] = null;
    }

    this.currentGameTemplate = this.getRandomGameTemplate();

    this.generateTiles();

    this.player.reset();

    this.prepareTempete();
    this.prepareOpenWater();
  }

}
